"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — WEIGHT & FITNESS CALCULATOR
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.weight_fitness_calculator = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-weight-tool">

        <div class="diafemme-weight-calculator">


            <p class="weight-intro">

                Estimate your ideal weight range, Body Mass Index (BMI),
                and Basal Metabolic Rate (BMR).

            </p>


            <div class="weight-disclaimer">

                These calculators provide general educational estimates only
                and do not replace medical or nutritional advice.

            </div>


            <!--==============================================================
            TABS
            ===============================================================-->

            <div class="weight-tabs">

                <button
                type="button"
                class="weight-tab-btn active"
                data-weight-tab="ideal">

                    Ideal Weight

                </button>


                <button
                type="button"
                class="weight-tab-btn"
                data-weight-tab="bmi">

                    BMI

                </button>


                <button
                type="button"
                class="weight-tab-btn"
                data-weight-tab="bmr">

                    BMR

                </button>

            </div>


            <!--==============================================================
            IDEAL WEIGHT
            ===============================================================-->

            <div
            class="weight-tab-content active"
            data-weight-content="ideal">


                <div class="weight-calculator-card">

                    <h3>Ideal Weight Range</h3>


                    <label>Height</label>


                    <div class="weight-inline-fields">

                        <input
                        type="number"
                        min="0"
                        placeholder="Feet"
                        data-weight-feet>


                        <input
                        type="number"
                        min="0"
                        max="11"
                        placeholder="Inches"
                        data-weight-inches>

                    </div>


                    <div class="weight-buttons">

                        <button
                        type="button"
                        class="weight-primary-btn"
                        data-weight-calculate-ideal>

                            Calculate

                        </button>


                        <button
                        type="button"
                        class="weight-secondary-btn"
                        data-weight-clear-ideal>

                            Clear

                        </button>

                    </div>


                    <div
                    class="weight-result-box"
                    data-weight-ideal-result
                    hidden>
                    </div>

                </div>

            </div>


            <!--==============================================================
            BMI
            ===============================================================-->

            <div
            class="weight-tab-content"
            data-weight-content="bmi">


                <div class="weight-calculator-card">

                    <h3>BMI Calculator</h3>


                    <label>Height</label>


                    <div class="weight-inline-fields">

                        <input
                        type="number"
                        min="0"
                        placeholder="Feet"
                        data-bmi-feet>


                        <input
                        type="number"
                        min="0"
                        max="11"
                        placeholder="Inches"
                        data-bmi-inches>

                    </div>


                    <label>Weight (kg)</label>


                    <input
                    type="number"
                    min="0"
                    placeholder="Weight in kg"
                    data-bmi-weight>


                    <div class="weight-buttons">

                        <button
                        type="button"
                        class="weight-primary-btn"
                        data-weight-calculate-bmi>

                            Calculate

                        </button>


                        <button
                        type="button"
                        class="weight-secondary-btn"
                        data-weight-clear-bmi>

                            Clear

                        </button>

                    </div>


                    <div
                    class="weight-result-box"
                    data-weight-bmi-result
                    hidden>
                    </div>

                </div>

            </div>


            <!--==============================================================
            BMR
            ===============================================================-->

            <div
            class="weight-tab-content"
            data-weight-content="bmr">


                <div class="weight-calculator-card">

                    <h3>BMR Calculator</h3>


                    <label>Age</label>


                    <input
                    type="number"
                    min="1"
                    placeholder="Age"
                    data-bmr-age>


                    <label>Height</label>


                    <div class="weight-inline-fields">

                        <input
                        type="number"
                        min="0"
                        placeholder="Feet"
                        data-bmr-feet>


                        <input
                        type="number"
                        min="0"
                        max="11"
                        placeholder="Inches"
                        data-bmr-inches>

                    </div>


                    <label>Weight (kg)</label>


                    <input
                    type="number"
                    min="0"
                    placeholder="Weight in kg"
                    data-bmr-weight>


                    <div class="weight-buttons">

                        <button
                        type="button"
                        class="weight-primary-btn"
                        data-weight-calculate-bmr>

                            Calculate

                        </button>


                        <button
                        type="button"
                        class="weight-secondary-btn"
                        data-weight-clear-bmr>

                            Clear

                        </button>

                    </div>


                    <div
                    class="weight-result-box"
                    data-weight-bmr-result
                    hidden>
                    </div>

                </div>

            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


/*==============================================================================*
*HELPERS
*==============================================================================*/

    const convertToCm = (feet,inches)=>{

        return (

            feet * 30.48 +

            inches * 2.54

        );

    };


    const getValue = (selector)=>{

        const element =

            root.querySelector(selector);


        return element

            ? parseFloat(element.value) || 0

            : 0;

    };


/*==============================================================================*
*TABS
*==============================================================================*/

    const tabButtons =

        root.querySelectorAll(

            "[data-weight-tab]"

        );


    const tabContents =

        root.querySelectorAll(

            "[data-weight-content]"

        );


    tabButtons.forEach(

        (button)=>{

            button.addEventListener(

                "click",

                ()=>{

                    const tab =

                        button.dataset.weightTab;


                    tabButtons.forEach(

                        (item)=>{

                            item.classList.remove("active");

                        }

                    );


                    tabContents.forEach(

                        (item)=>{

                            item.classList.remove("active");

                        }

                    );


                    button.classList.add("active");


                    const content =

                        root.querySelector(

                            `[data-weight-content="${tab}"]`

                        );


                    if(content){

                        content.classList.add("active");

                    }

                }

            );

        }

    );


/*==============================================================================*
*IDEAL WEIGHT
*==============================================================================*/

    const idealResult =

        root.querySelector(

            "[data-weight-ideal-result]"

        );


    const calculateIdeal =

        root.querySelector(

            "[data-weight-calculate-ideal]"

        );


    if(calculateIdeal){

        calculateIdeal.addEventListener(

            "click",

            ()=>{

                const feet =

                    getValue("[data-weight-feet]");


                const inches =

                    getValue("[data-weight-inches]");


                if(

                    feet <= 0 &&
                    inches <= 0

                ){

                    alert("Please enter your height.");

                    return;

                }


                const heightCm =

                    convertToCm(

                        feet,

                        inches

                    );


                const heightM =

                    heightCm / 100;


                const lower =

                    18.5 *

                    heightM *

                    heightM;


                const upper =

                    23 *

                    heightM *

                    heightM;


                idealResult.innerHTML = `

                    <h4>Estimated Ideal Weight Range</h4>

                    <div class="weight-result-number">

                        ${lower.toFixed(1)}
                        –
                        ${upper.toFixed(1)} kg

                    </div>

                    <p>

                        This estimate uses a BMI range of 18.5–23.

                    </p>

                `;


                idealResult.hidden = false;

            }

        );

    }


/*==============================================================================*
*CLEAR IDEAL
*==============================================================================*/

    const clearIdeal =

        root.querySelector(

            "[data-weight-clear-ideal]"

        );


    if(clearIdeal){

        clearIdeal.addEventListener(

            "click",

            ()=>{

                root.querySelector(

                    "[data-weight-feet]"

                ).value = "";


                root.querySelector(

                    "[data-weight-inches]"

                ).value = "";


                idealResult.hidden = true;

                idealResult.innerHTML = "";

            }

        );

    }


/*==============================================================================*
*BMI
*==============================================================================*/

    const bmiResult =

        root.querySelector(

            "[data-weight-bmi-result]"

        );


    const calculateBMI =

        root.querySelector(

            "[data-weight-calculate-bmi]"

        );


    if(calculateBMI){

        calculateBMI.addEventListener(

            "click",

            ()=>{

                const feet =

                    getValue("[data-bmi-feet]");


                const inches =

                    getValue("[data-bmi-inches]");


                const weight =

                    getValue("[data-bmi-weight]");


                if(

                    (
                        feet <= 0 &&
                        inches <= 0
                    ) ||
                    weight <= 0

                ){

                    alert("Please fill all BMI fields.");

                    return;

                }


                const heightM =

                    convertToCm(

                        feet,

                        inches

                    ) / 100;


                const bmi =

                    weight /

                    (

                        heightM *

                        heightM

                    );


                let category = "";


                if(bmi < 18.5){

                    category = "Underweight";

                }

                else if(bmi < 23){

                    category = "Healthy Range";

                }

                else if(bmi < 25){

                    category = "Above Healthy Range";

                }

                else if(bmi < 30){

                    category = "Overweight";

                }

                else{

                    category = "Obesity Range";

                }


                bmiResult.innerHTML = `

                    <h4>Your Estimated BMI</h4>

                    <div class="weight-result-number">

                        ${bmi.toFixed(1)}

                    </div>

                    <p>

                        ${category}

                    </p>

                `;


                bmiResult.hidden = false;

            }

        );

    }


/*==============================================================================*
*CLEAR BMI
*==============================================================================*/

    const clearBMI =

        root.querySelector(

            "[data-weight-clear-bmi]"

        );


    if(clearBMI){

        clearBMI.addEventListener(

            "click",

            ()=>{

                [

                    "[data-bmi-feet]",
                    "[data-bmi-inches]",
                    "[data-bmi-weight]"

                ].forEach(

                    (selector)=>{

                        root.querySelector(

                            selector

                        ).value = "";

                    }

                );


                bmiResult.hidden = true;

                bmiResult.innerHTML = "";

            }

        );

    }


/*==============================================================================*
*BMR
*==============================================================================*/

    const bmrResult =

        root.querySelector(

            "[data-weight-bmr-result]"

        );


    const calculateBMR =

        root.querySelector(

            "[data-weight-calculate-bmr]"

        );


    if(calculateBMR){

        calculateBMR.addEventListener(

            "click",

            ()=>{

                const age =

                    getValue("[data-bmr-age]");


                const feet =

                    getValue("[data-bmr-feet]");


                const inches =

                    getValue("[data-bmr-inches]");


                const weight =

                    getValue("[data-bmr-weight]");


                if(

                    age <= 0 ||
                    (
                        feet <= 0 &&
                        inches <= 0
                    ) ||
                    weight <= 0

                ){

                    alert("Please fill all BMR fields.");

                    return;

                }


                const heightCm =

                    convertToCm(

                        feet,

                        inches

                    );


                const bmr =

                    9.247 * weight +

                    3.098 * heightCm -

                    4.33 * age +

                    447.593;


                bmrResult.innerHTML = `

                    <h4>Your Estimated BMR</h4>

                    <div class="weight-result-number">

                        ${Math.round(bmr)}

                        <small>kcal/day</small>

                    </div>

                    <p>

                        This estimates the energy your body may use
                        at rest each day.

                    </p>

                `;


                bmrResult.hidden = false;

            }

        );

    }


/*==============================================================================*
*CLEAR BMR
*==============================================================================*/

    const clearBMR =

        root.querySelector(

            "[data-weight-clear-bmr]"

        );


    if(clearBMR){

        clearBMR.addEventListener(

            "click",

            ()=>{

                [

                    "[data-bmr-age]",
                    "[data-bmr-feet]",
                    "[data-bmr-inches]",
                    "[data-bmr-weight]"

                ].forEach(

                    (selector)=>{

                        root.querySelector(

                            selector

                        ).value = "";

                    }

                );


                bmrResult.hidden = true;

                bmrResult.innerHTML = "";

            }

        );

    }

}

};